import { Box, Typography, useTheme } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import { CompanyAssessmentOutletContext } from "./CompanyAssessment";
import OrgGraphVis from "org-graph/OrgGraphVis";
import { useAuth } from "react-oidc-context";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

export default function CompanyAssessmentIndex() {
  const { t } = useTranslation();
  const { orgGraphRef, topBarContent, isFullscreen, setIsFullscreen } = useOutletContext<CompanyAssessmentOutletContext>();
  const auth = useAuth();
  const muiTheme = useTheme();
  const isDarkMode = muiTheme.palette.mode === 'dark';

  useEffect(() => {
    // Force background color override since OrgGraphVis defaults to black when no orgNumber is present
    const container = document.querySelector('#org-graph-card .org-graph-container') as HTMLElement;
    if (container) {
      container.style.setProperty('background-color', muiTheme.palette.background.default, 'important');
    }
  }, [isDarkMode, muiTheme.palette.background.default, isFullscreen]);

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* Graph Background */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }}>
        <Box id="org-graph-card" sx={{ width: '100%', height: '100%' }}>
          <OrgGraphVis
            ref={orgGraphRef}
            nodes={[]}
            relationships={[]}
            orgNumber=""
            graphMetaData={{}}
            showFilterButtons={true}
            getAccessToken={() => auth.user?.access_token}
            topPanelLeftSpacerWidth="650px"
            legendLeftOffset="70px"
            isFullscreen={isFullscreen}
            onToggleFullscreen={setIsFullscreen}
            isDarkMode={isDarkMode}
            topBarContent={topBarContent}
          />
        </Box>
      </Box>

      {/* Message Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          zIndex: 5,
          pointerEvents: 'none',
          width: 'calc(100% - 48px)',
          maxWidth: 440,
          px: 3,
          py: 2.5,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 3,
        }}
      >
        <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500, lineHeight: 1.6 }}>
          {t('assessment.details.enterOrgToBegin')}
        </Typography>
      </Box>
    </Box>
  );
}
